module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9gcl5U/tc-custom/9781611522235.jpg?1723403853805",
      "alt": "This image is the cover for the book David and Andrew Book 1: One Night in December, David and Andrew"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("David and Andrew Book 1: One Night in December, David and Andrew\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("David Bennett is a widower. He had a wonderful relationship with his wife, but now she's gone. He decides he's done with relationships -- he has no sex drive and no interest in life in general."), _c('br'), _c('br'), _vm._v("Andy Barnes is a homeless man who often stands at the end of an exit ramp begging for help. For some unfathomable reason, David is always tempted to pick him up on his way home. One wretched night in December, fate intervenes and David finds himself bringing the man home and into his life."), _c('br'), _c('br'), _vm._v("Much to his surprise, he begins to fall in love with this down and out young man. As love returns, David realizes he does have a reason to go on with life after all."), _c('br'), _c('br'), _vm._v("Over the next few years, the two face life as a partnered gay couple with humor and courage. Each year brings with it happiness, tragedy, joy, and sorrow; the stuff life is made of. Along the way, the love the two share for each other helps them to overcome all obstacles and face all challenges.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terry O'Reilly\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0